import { useMemo } from "react";
import { Bibliography } from "../../types/bibliography";
import { initMetadata } from "../../controllers/formController";
import { SystemEntityProofreadingStatus } from "../../shared/enums/shared-enums";

const useBibliographyLogic = () => {
  const userEnums = useMemo<string[]>(() => ["ardi_jababo"], []);

  const metadataFieldNames = useMemo<Array<keyof Bibliography>>(() => [], []);

  const defaultBibliography = useMemo<Bibliography>(() => {
    return {
      _id: "",
      _rev: "",
      _key: "",
      published_id: "",
      ardi_id: undefined,
      filename: "",
      author: "",
      title: "",
      volumes: "",
      year: "",
      sanskritof: "",
      sans_complete: "",
      sans_tohoku: "",
      sans_otani: "",
      tibetanof: "",
      tibe_complete: "",
      tibe_tohoku: "",
      tibe_otani: "",
      journal: "",
      startpage: "",
      endpage: "",
      booktitle: "",
      bookeditor: "",
      seriesname: "",
      seriesnumber: "",
      serieseditor: "",
      publicationplace: "",
      publisher: "",
      source: "",
      jababo: "",
      owner: "",
      no_of_volumes: "",
      volume_no: "",
      notes: "",
      internal_notes: "",
      entity_status_of_proofreading: SystemEntityProofreadingStatus.NOT_PROOFREAD,
      attributes_metadata: initMetadata<Bibliography>(metadataFieldNames),
    };
  }, [metadataFieldNames]);

  const getDisplayName = (bibliography?: Bibliography | null): string =>
    `Bibliography${bibliography?.published_id ? `: ${bibliography.published_id}` : ""}`;

  return {
    userEnums,
    metadataFieldNames,
    defaultBibliography,
    getDisplayName,
  };
};

export default useBibliographyLogic;

